// extracted by mini-css-extract-plugin
export default {"content":"DuplicatesRemoveLimitModal__content--1kUqq","imageWrapper":"DuplicatesRemoveLimitModal__imageWrapper--2HdxO"};